module.exports = __webpack_public_path__ + "static/media/arrow-up.f81a4cc0.svg";